export const VERT_DIM = 257;
export const MAP_UNITS = 256;
// Heights from heightmap.bin are already in SC2 world units (raw int16 / 512 in the
// exporter), matching the placement-coord scale used by Object z values. No extra scaling.
export const HEIGHT_VISUAL_SCALE = 1;
